import type { IteroPatientSortField, IteroSortOrder } from '../../../../services/iteroBrowse';

// The iTero sort fields that have a column header to click.
export type PatientSortKey = Extract<IteroPatientSortField, 'LastName' | 'LastScanDate'>;

export interface PatientSort {
    by: PatientSortKey;
    order: IteroSortOrder;
}

export const DEFAULT_PATIENT_SORT: PatientSort = { by: 'LastScanDate', order: 'desc' };

const FIRST_CLICK_ORDER: Record<PatientSortKey, IteroSortOrder> = {
    LastName: 'asc',
    LastScanDate: 'desc'
};

// Clicking the sorted column flips its direction; another column starts in its natural order.
export function sortAfterHeaderClick(current: PatientSort, column: PatientSortKey): PatientSort {
    if (current.by !== column) return { by: column, order: FIRST_CLICK_ORDER[column] };
    return { by: column, order: current.order === 'desc' ? 'asc' : 'desc' };
}
